










import { Component, Vue,Prop,Watch } from 'vue-property-decorator'
import { Ranking } from '@/api/home'
import NoData from '@/components/NoData'

const echarts = require('echarts')
@Component({
  name: 'ConsumptionSanking',
  components:{NoData}
})

export default class ConsumptionSanking extends Vue {
  private data : any =[]
  @Prop({default:''}) code!:string
  RankingdData(e:any){
    Ranking({
      regionCode:e
    }).then((res :any)=>{
      if(res.status == 0){
        this.data = []
        res.data.forEach((item:any) =>{
          this.data.push([Number(item.dataValue) , item.industryName])
        })
        this.init()
      }
    //   if(!res.data){
    //     this.data = null
    //   }
    }).catch(err =>{
    })
  }
  updatafun(){
    setTimeout(() => {
      this.init()
    }, 0)
  }
  init(){
      const main = document.getElementById('ConsumptionSanking')
      // 基于准备好的dom，初始化echarts实例
      const myChart:any = echarts.init(main as HTMLDivElement)
      // 指定图表的配置项和数据
      const option = {
        tooltip: {},
        grid: {
          top:'8%',
          // top:'6%',
          left: '0',
          // right: '2%',
          bottom: '3%',
          containLabel: true
        },
        // legend: {
        //   data: ['销量'],
        // },
        // yAxis: {
        //   color:['#1693ed'],
        //   type: 'value',
        // },
        // barCategoryGap:'65%',
        yAxis:{
            type:'category',
            inverse: true,//倒叙
            splitLine:{
                show:false
            },
            axisTick: {
                show: false
            },
              axisLine: {show: false},
            axisLabel:{
                    // interval:0,
                    textStyle: {
                        align:'right',
                        baseline:'middle'
                    },
                formatter: function(value:any) {
                    let formatterres = value
                    if(formatterres.length > 5) {
                        formatterres = formatterres.substring(0, 5) + '..'
                    }
                    return formatterres
                }
                }
        },
        xAxis: {
          type:'value',
          axisLine: {show: false},
           splitLine:{
                show:false
            },
        },
        series: [
          {
            barWidth:10,
            name: '',
            type: 'bar',
            itemStyle:{
              normal:{
                // label:{
                //   show:true,
                //   position:'right',
                //   textStyle:{color:'#000'}
                // },
                barBorderRadius: [5, 5, 5, 5],
              }
					  },
            data:this.data,
          }
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
  }
    @Watch('code')
    onChangeData(e:any) {
        this.RankingdData(e)
    }
    mounted() {
        this.RankingdData(this.code)
    }
}


